export const CODE_GENERATOR_SUPPORTED_ENTITIES = [
    { value: 'App\\Entity\\Common\\Employee', label: 'entity-common-employee' },
    { value: 'App\\Entity\\CRM\\Client', label: 'entity-crm-client' },
    { value: 'App\\Entity\\CRM\\Contract', label: 'entity-crm-contract' },
    { value: 'App\\Entity\\WorkManagement\\BusinessOpportunity', label: 'entity-workmgmt-businessopportunity' },
    { value: 'App\\Entity\\WorkManagement\\Task', label: 'entity-workmgmt-task' },
    { value: 'App\\Entity\\WorkManagement\\Ticket', label: 'entity-workmgmt-ticket' },
    { value: 'App\\Entity\\WorkManagement\\WorkOrder', label: 'entity-workmgmt-workorder' }
];

export const CODE_GENERATOR_MODES = ['pattern_replacement', 'array_join'];
export const CODE_GENERATOR_PART_TYPES = ['static_value', 'counter', 'field_value_local', 'field_value_external', 'date', 'current_year'];
export const CODE_GENERATOR_COUNTER_DIRECTIONS = ['asc', 'desc'];
export const CODE_GENERATOR_COUNTER_INTERVALS = ['none', 'daily', 'weekly', 'biweekly', 'monthly', 'quarterly', 'biannual', 'yearly'];

export const createCodeGeneratorPart = (partType = 'static_value') => ({
    partType,
    value: '',
    direction: 'asc',
    interval: 'none',
    length: '',
    format: 'Y',
    timezone: '',
    fieldName: '',
    externalEntityFieldName: ''
});

export const createDefaultCodeGeneratorData = () => ({
    applyGenerator: true,
    targetFieldName: 'code',
    generatorMode: 'pattern_replacement',
    pattern: 'p1-p2',
    glue: '-',
    parts: [createCodeGeneratorPart('static_value'), createCodeGeneratorPart('counter')]
});

export const buildAutoPatternFromParts = (parts = []) => parts.map((_, index) => `p${index + 1}`).join('-');

export const getCodeGeneratorEntityOption = (className) =>
    CODE_GENERATOR_SUPPORTED_ENTITIES.find((option) => option.value === className) || null;

export const getCodeGeneratorEntityLabelId = (className) => getCodeGeneratorEntityOption(className)?.label || null;

export const buildCodeGeneratorPartPreview = (part = {}) => {
    switch (part?.partType) {
        case 'static_value':
            return part?.value || 'TXT';
        case 'counter': {
            const length = Number.isInteger(part?.length) ? part.length : parseInt(part?.length, 10);
            const safeLength = Number.isInteger(length) && length > 0 ? length : 6;
            return ''.padStart(safeLength, '0').slice(-safeLength);
        }
        case 'field_value_local':
            return `{${part?.fieldName || 'field'}}`;
        case 'field_value_external':
            return `{${part?.fieldName || 'relation'}.${part?.externalEntityFieldName || 'field'}}`;
        case 'date':
            return `{date:${part?.format || 'Y'}}`;
        case 'current_year':
            return new Date().getFullYear().toString();
        default:
            return '?';
    }
};

export const buildCodeGeneratorPreview = (data = {}) => {
    const parts = Array.isArray(data?.parts) ? data.parts : [];
    const previewParts = parts.map((part) => buildCodeGeneratorPartPreview(part));

    if (previewParts.length === 0) {
        return '';
    }

    if (data?.generatorMode === 'array_join') {
        return previewParts.join(data?.glue ?? '-');
    }

    const pattern = typeof data?.pattern === 'string' && data.pattern.trim() ? data.pattern : buildAutoPatternFromParts(parts);

    return previewParts.reduce((result, partPreview, index) => result.replaceAll(`p${index + 1}`, partPreview), pattern);
};

export const formatCodeGeneratorDataText = (data = {}) => {
    const preview = buildCodeGeneratorPreview(data);
    const targetFieldName = data?.targetFieldName || 'code';

    if (!preview) {
        return '';
    }

    return `${targetFieldName}: ${preview}`;
};
